<template>
  <div class="home-container">
    <!-- 导航 -->
 
    <div class="big_img"></div>
    <div
      style="margin:0 auto;width: 1200px;display: flex;align-items: center;justify-content: space-between;flex-wrap: wrap;margin-top: 43px">
      <div class="img_container">
        <div style="width: 263px;height:163px;">
          <img src="../../static/img/8.png" alt style="width: 100%;height: 100%;" />
        </div>
        <div class="card">
          <div class="card_moive">
            <div style="width: 40px;height: 35px;background: orange;position: absolute;top:42px;left: 39px;">
              <img src="../../static/img/home/LOGO1.png" alt style="width:100%;height:100%" />
            </div>
            <div style="position: absolute;top: 111px;left: 39px;">连锁店家：梦络缇养生会所</div>
          </div>
        </div>
      </div>
      <div class="img_container">
        <div style="width: 263px;height:163px;">
          <img src="../../static/img/10.png" alt style="width: 100%;height: 100%;" />
        </div>
        <div class="card">
          <div class="card_moive">
            <div style="width: 40px;height: 35px;background: orange;position: absolute;top:42px;left: 39px;">
              <img src="../../static/img/home/LOGO1.png" alt style="width:100%;height:100%" />
            </div>
            <div style="position: absolute;top: 111px;left: 39px;">连锁店家：梦络缇养生会所</div>
          </div>
        </div>
      </div>
      <div class="img_container">
        <div style="width: 263px;height:163px;">
          <img src="../../static/img/11.png" alt style="width: 100%;height: 100%;" />
        </div>
        <div class="card">
          <div class="card_moive">
            <div style="width: 40px;height: 35px;background: orange;position: absolute;top:42px;left: 39px;">
              <img src="../../static/img/home/LOGO1.png" alt style="width:100%;height:100%" />
            </div>
            <div style="position: absolute;top: 111px;left: 39px;">连锁店家：梦络缇养生会所</div>
          </div>
        </div>
      </div>
      <div class="img_container">
        <div style="width: 263px;height:163px;">
          <img src="../../static/img/12.png" alt style="width: 100%;height: 100%;" />
        </div>
        <div class="card">
          <div class="card_moive">
            <div style="width: 40px;height: 35px;background: orange;position: absolute;top:42px;left: 39px;">
              <img src="../../static/img/home/LOGO1.png" alt style="width:100%;height:100%" />
            </div>
            <div style="position: absolute;top: 111px;left: 39px;">连锁店家：梦络缇养生会所</div>
          </div>
        </div>
      </div>
      <div class="img_container">
        <div style="width: 263px;height:163px;">
          <img src="../../static/img/8.png" alt style="width: 100%;height: 100%;" />
        </div>
        <div class="card">
          <div class="card_moive">
            <div style="width: 40px;height: 35px;background: orange;position: absolute;top:42px;left: 39px;">
              <img src="../../static/img/home/LOGO1.png" alt style="width:100%;height:100%" />
            </div>
            <div style="position: absolute;top: 111px;left: 39px;">连锁店家：梦络缇养生会所</div>
          </div>
        </div>
      </div>
      <div class="img_container">
        <div style="width: 263px;height:163px;">
          <img src="../../static/img/8.png" alt style="width: 100%;height: 100%;" />
        </div>
        <div class="card">
          <div class="card_moive">
            <div style="width: 40px;height: 35px;background: orange;position: absolute;top:42px;left: 39px;">
              <img src="../../static/img/home/LOGO1.png" alt style="width:100%;height:100%" />
            </div>
            <div style="position: absolute;top: 111px;left: 39px;">连锁店家：梦络缇养生会所</div>
          </div>
        </div>
      </div>
      <div class="img_container">
        <div style="width: 263px;height:163px;">
          <img src="../../static/img/8.png" alt style="width: 100%;height: 100%;" />
        </div>
        <div class="card">
          <div class="card_moive">
            <div style="width: 40px;height: 35px;background: orange;position: absolute;top:42px;left: 39px;">
              <img src="../../static/img/home/LOGO1.png" alt style="width:100%;height:100%" />
            </div>
            <div style="position: absolute;top: 111px;left: 39px;">连锁店家：梦络缇养生会所</div>
          </div>
        </div>
      </div>
      <div class="img_container">
        <div style="width: 263px;height:163px;">
          <img src="../../static/img/8.png" alt style="width: 100%;height: 100%;" />
        </div>
        <div class="card">
          <div class="card_moive">
            <div style="width: 40px;height: 35px;background: orange;position: absolute;top:42px;left: 39px;">
              <img src="../../static/img/home/LOGO1.png" alt style="width:100%;height:100%" />
            </div>
            <div style="position: absolute;top: 111px;left: 39px;">连锁店家：梦络缇养生会所</div>
          </div>
        </div>
      </div>
      <div class="img_container">
        <div style="width: 263px;height:163px;">
          <img src="../../static/img/8.png" alt style="width: 100%;height: 100%;" />
        </div>
        <div class="card">
          <div class="card_moive">
            <div style="width: 40px;height: 35px;background: orange;position: absolute;top:42px;left: 39px;">
              <img src="../../static/img/home/LOGO1.png" alt style="width:100%;height:100%" />
            </div>
            <div style="position: absolute;top: 111px;left: 39px;">连锁店家：梦络缇养生会所</div>
          </div>
        </div>
      </div>
      <div class="img_container">
        <div style="width: 263px;height:163px;">
          <img src="../../static/img/8.png" alt style="width: 100%;height: 100%;" />
        </div>
        <div class="card">
          <div class="card_moive">
            <div style="width: 40px;height: 35px;background: orange;position: absolute;top:42px;left: 39px;">
              <img src="../../static/img/home/LOGO1.png" alt style="width:100%;height:100%" />
            </div>
            <div style="position: absolute;top: 111px;left: 39px;">连锁店家：梦络缇养生会所</div>
          </div>
        </div>
      </div>
      <div class="img_container">
        <div style="width: 263px;height:163px;">
          <img src="../../static/img/8.png" alt style="width: 100%;height: 100%;" />
        </div>
        <div class="card">
          <div class="card_moive">
            <div style="width: 40px;height: 35px;background: orange;position: absolute;top:42px;left: 39px;">
              <img src="../../static/img/home/LOGO1.png" alt style="width:100%;height:100%" />
            </div>
            <div style="position: absolute;top: 111px;left: 39px;">连锁店家：梦络缇养生会所</div>
          </div>
        </div>
      </div>
      <div class="img_container">
        <div style="width: 263px;height:163px;">
          <img src="../../static/img/8.png" alt style="width: 100%;height: 100%;" />
        </div>
        <div class="card">
          <div class="card_moive">
            <div style="width: 40px;height: 35px;background: orange;position: absolute;top:42px;left: 39px;">
              <img src="../../static/img/home/LOGO1.png" alt style="width:100%;height:100%" />
            </div>
            <div style="position: absolute;top: 111px;left: 39px;">连锁店家：梦络缇养生会所</div>
          </div>
        </div>
      </div>
      <div class="img_container">
        <div style="width: 263px;height:163px;">
          <img src="../../static/img/8.png" alt style="width: 100%;height: 100%;" />
        </div>
        <div class="card">
          <div class="card_moive">
            <div style="width: 40px;height: 35px;background: orange;position: absolute;top:42px;left: 39px;">
              <img src="../../static/img/home/LOGO1.png" alt style="width:100%;height:100%" />
            </div>
            <div style="position: absolute;top: 111px;left: 39px;">连锁店家：梦络缇养生会所</div>
          </div>
        </div>
      </div>
      <div class="img_container">
        <div style="width: 263px;height:163px;">
          <img src="../../static/img/8.png" alt style="width: 100%;height: 100%;" />
        </div>
        <div class="card">
          <div class="card_moive">
            <div style="width: 40px;height: 35px;background: orange;position: absolute;top:42px;left: 39px;">
              <img src="../../static/img/home/LOGO1.png" alt style="width:100%;height:100%" />
            </div>
            <div style="position: absolute;top: 111px;left: 39px;">连锁店家：梦络缇养生会所</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import RMTopDiv from '../../src/page/RMTopDiv.vue'
  import { mapGetters } from "vuex";
  import { mapMutations } from "vuex";
  import * as types from "../store/mutation-types";
  export default {
    components: {RMTopDiv},
    data() {
      return {
        scroll: '',
        scroll100: true,
        scroll700: false
      };
    },
    watch: {
      scroll: function () {
        this.loadSroll();
      }
    },
    methods: {
      //首页
      goToHome() {
        this.$router.push("/");
      },
      //产品中心-店务系统介绍
      goToDw() {
        this.$router.push("./home");
      },
      //产品中心-供应链
      goToSupply() {
        this.$router.push("./supplyChain");
      },
      //产品中心-营销工具
      goToMark() {
        this.$router.push("./marketingTools");
      },
      //关于我们-公司简介
      goToUS() {
        this.$router.push("./company");
      },
      //关于我们-合作渠道
      goToChannel() {
        this.$router.push("./channels");
      },
      //关于我们-招聘
      goToContact() {
        this.$router.push("./contact");
      },
      //关于我们-企业文化
      goToCulture() {
        this.$router.push("./culture");
      },
     //找美商学院-商学院文化
     goToCollege(){
        this.$router.push("./school");
      },
      //找美商学院-走进阿里
      goToAli(){
        this.$router.push("./Ali");
      },
       //找美商学院-行程安排
      gotoTravell(){
        this.$router.push('./Travell')
      },
       //找美商学院-讲师简介
      goToTeach(){},
       //找美商学院-相关案例
      goToCase(){},
      dataScroll(event) {
        this.scroll = document.documentElement.scrollTop || document.body.scrollTop || event.target.scrollTop
      },
      loadSroll: function () {
        if (this.scroll <= 100) {
          this.scroll100 = true
        } else {
          this.scroll100 = false
        }
        if (this.scroll > 100) {
          this.scroll700 = true
        } else {
          this.scroll700 = false
        }
      },
    },
    created() { },
    computed: {
      ...mapGetters(["username", "password", "treeData", "stafftype", "limit"])
    },
    mounted() {
      //获取高度
      window.addEventListener("scroll", this.dataScroll, true);
    }
  };
</script>

<style scoped lang="scss">
  @import "../assets/css/them.scss";

  .home-container {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
  }


  .big_img {
    background-image: url('../../static/img/more_bg.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 738px;
    position: relative;
    top: 0;
    left: 0;
  }

  .img_container {
    height: 326px;
    width: 263px;
    background: #F9F9F9;
    overflow: hidden;
    margin-top: 34px;
    position: relative;
  }

  .card {
    width: 263px;
    height: 326px;
    background: #F9F9F9;
    position: absolute;
    top: 163px;
    transition: all 0.5s;
    /* // box-shadow:2px 2px 2px 2px rgba(0,255,255,1); */
  }

  .card_moive {
    position: relative;
    width: 100%;
    height: 100%;
    background: #F9F9F9;
  }

  .img_container:hover .card {
    margin-top: -163px;
    transition: all 0.5s;
  }
</style>


// WEBPACK FOOTER //
// src/page/moreShop.vue